export default __webpack_public_path__ + "static/media/brought-to-you-by-a-falling-bob-omb-by-0x10.855b6ac4.mp3";